"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WABA360DialogPartnerClientPayloadsEnumsTemplateStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var WABA360DialogPartnerClientPayloadsEnumsTemplateStatus;
(function (WABA360DialogPartnerClientPayloadsEnumsTemplateStatus) {
    WABA360DialogPartnerClientPayloadsEnumsTemplateStatus["Unknown"] = "unknown";
    WABA360DialogPartnerClientPayloadsEnumsTemplateStatus["Created"] = "created";
    WABA360DialogPartnerClientPayloadsEnumsTemplateStatus["Submitted"] = "submitted";
    WABA360DialogPartnerClientPayloadsEnumsTemplateStatus["Pending"] = "pending";
    WABA360DialogPartnerClientPayloadsEnumsTemplateStatus["Approved"] = "approved";
    WABA360DialogPartnerClientPayloadsEnumsTemplateStatus["Rejected"] = "rejected";
})(WABA360DialogPartnerClientPayloadsEnumsTemplateStatus = exports.WABA360DialogPartnerClientPayloadsEnumsTemplateStatus || (exports.WABA360DialogPartnerClientPayloadsEnumsTemplateStatus = {}));
